export default "__VITE_ASSET__DOG1FGh___"